import { FileType } from "@/domain/upload/value-objects/FileType";
import { UploadStatus } from "@/domain/upload/value-objects/UploadStatus";
import {
  UploadPlaceholderRecordDTO,
  UploadTaskDTO,
} from "@/application/upload/dtos/UploadTaskDTO";

export interface UploadTaskViewModel {
  fileId: string;
  name: string;
  originalFileName: string;
  status: UploadStatus;
  progress: number;
  type: FileType;
  sizeMb?: number;
  durationSec?: number | null;
  error?: string;
  placeholderRecord?: UploadPlaceholderRecordDTO;
}

export const mapUploadTaskDtoToViewModel = (
  task: UploadTaskDTO
): UploadTaskViewModel => ({
  fileId: task.id,
  name: task.name,
  originalFileName: task.originalFileName,
  status: task.status,
  progress: task.progress,
  type: task.type,
  sizeMb: task.sizeMb,
  durationSec: task.durationSec,
  error: task.error,
  placeholderRecord: task.placeholderRecord,
});

